import { REGEX_NON_INDEXED_LEGAL } from './constants';
/**
 * Searches the input string and returns an array of slugs
 * corresponding to non-indexed legals.
 *
 * @param str Input string.
 * @returns An array of non-indexed legal slugs.
 */
export default function findNonIndexedLegals(str) {
    const matches = [...str.matchAll(REGEX_NON_INDEXED_LEGAL)];
    return matches.map((match) => match[2]);
}
